import React, { useState, useEffect, useRef } from "react";
import "../style.scss";
import "./style.scss";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCornerPodcastDetails, cornerSectionOverview} from "../actions";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { getRouting } from "../../../../../utils/common";

const PodcastDetail = (props) => {
 const {
   getCornerPodcastDetails,
   podcastDetailsList,
   cornerSectionOverview,
   cornerOverviewList,
   location: { pathname },
 } = props;

 const current = pathname.split("/")[3] ? pathname.split("/")[3] : "";
 const [podcastDetailList, setpodcastDetailList] = useState();
 const [defaultAudio, setDefaultAudio] = useState([]);
 const [metaData, setMetaData] = useState("");
 const [cornerOverviewTab, setcornerOverviewTab] = useState("");

 useEffect(() => {
   if(current){
     getCornerPodcastDetails({},current);
   }
   cornerSectionOverview();
 }, [current]);

 useEffect(() => {
   if (
     podcastDetailsList &&
     podcastDetailsList.podcast &&
     podcastDetailsList.podcast[0]
   ) {
     setpodcastDetailList(podcastDetailsList.podcast[0]);
     window.scrollTo(0, 0);
   }

   if (
     podcastDetailsList &&
     podcastDetailsList.podcast &&
     podcastDetailsList.podcast[0] &&
     podcastDetailsList.podcast[0].episodes &&
     podcastDetailsList.podcast[0].episodes[0]
   ) {
     setDefaultAudio(podcastDetailsList.podcast[0].episodes[0]);
   }

   if (
     podcastDetailsList &&
     podcastDetailsList.meta
   ) {
     setMetaData(podcastDetailsList.meta);
   }

 }, [podcastDetailsList]);

 useEffect(() => {
   if (cornerOverviewList && cornerOverviewList.cornerOverview) {
     setcornerOverviewTab(cornerOverviewList.cornerOverview);
   }
 }, [cornerOverviewList]);

 const handleChangeAudio = async (e, item) => {
   setDefaultAudio(item);
   window.scrollTo(0, 0);
 };

 //dropdown start

 const [isOpen, setIsOpen] = useState(false);
 const dropdownRef = useRef(null);

 const toggleDropDown = () => {
   setIsOpen(!isOpen);
 };

 const handleClickOut = (event) => {
   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
     setIsOpen(false);
   }
 };

 useEffect(() => {
   document.addEventListener("click", handleClickOut);
   return () => {
     document.removeEventListener("click", handleClickOut);
   };
 }, [isOpen]);

 //dropdown end

 return (
   <div className="wrapper">
     {metaData && metaData !== null && <Helmet>
         <title>{metaData.title ? metaData.title : ""}</title>
         <meta name="description" content={metaData.description ? metaData.description : ""} />
         <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
         <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
         <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
         <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
         <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
     </Helmet>}
     <section className="aboutHead">
       <div className="container">
         <div className="d-flex dropdowncls">
           <div class="dropdown me-auto" ref={dropdownRef}>
             <div
               id="dropdownMenuLink"
               // data-bs-toggle="dropdown"
               // aria-expanded="false"
               onClick={toggleDropDown}
             >
               <h1>
                 <span>Podcast</span>
                 <img
                   className="ms-2"
                   src="/images/New/redDownArrow.svg"
                   alt=""
                 />
               </h1>
             </div>
             {isOpen && (
               <ul class="dropdown-body" aria-labelledby="dropdownMenuLink">
                 {cornerOverviewTab &&
                   cornerOverviewTab.length > 0 &&
                   cornerOverviewTab.map((over, index) =>
                     over.linkName != "Podcast" ? (
                       <li>
                         <a
                           class="dropdown-item fw-bold"
                           href={over.linkName=='Quiz' ? over.linkUrl : over.routeConstant}
                         >
                           {over.linkName}
                         </a>
                       </li>
                     ) : null
                   )}
               </ul>
             )}
           </div>
           <nav
             aria-label="breadcrumb"
             className="align-self-center breadCrumbCust d-md-inlin"
           >
             <ol className="breadcrumb mb-0">
               <li className="breadcrumb-item">
                 <Link to={getRouting(`/`)}>Home</Link>
               </li>
               <li className="breadcrumb-item">
                 <Link to={getRouting(`/learners-corner`)}>
                   Learners’ Corner
                 </Link>
               </li>
               <li className="breadcrumb-item">
                 <Link to={getRouting(`/learners-corner/podcast`)}>
                   Podcast
                 </Link>
               </li>
             </ol>
           </nav>
         </div>
       </div>
     </section>
     <section>
       <div className="container defaultaudio">
         <div className="p-4 p-md-5 firstdiv mt-5">
           <div className="pcdiv"></div>
           <div className="row">
             <div className="col-md-12 my-auto">
               <h3 className="mb-5 text-center podheading">
                 {podcastDetailList && podcastDetailList.title}
               </h3>
             </div>
             <div className="col-md-9 mbottom p-4 mx-auto">
               <div>
                 <div className="row">
                   <div className="col-md-3 d-flex align-items-center justify-content-center podimage">
                     <img
                       src={
                         defaultAudio.thumbnail ? defaultAudio.thumbnail : ""
                       }
                       className="img-fluid"
                     />
                   </div>
                   <div className="col-md-9">
                     <h3 className="bluecolor">
                       {defaultAudio.title ? defaultAudio.title : ""}
                     </h3>
                     <p className="my-3">
                       {defaultAudio.description
                         ? defaultAudio.description
                         : ""}{" "}
                       visit -
                       <a href={defaultAudio.url} className="text-break">
                         {defaultAudio.url}
                       </a>
                     </p>
                   </div>
                   <div className="col-md-12 mt-3">
                     <audio
                       preload="auto"
                       src={defaultAudio && defaultAudio.file}
                       class="w-100"
                       controls
                     >
                       <source src={defaultAudio && defaultAudio.file} />
                     </audio>
                   </div>
                 </div>
               </div>
             </div>
           </div>
           <div className="pcdiv1"></div>
         </div>
       </div>
       <div className="container">
         <div className="podcastdiv">
           <div className="row">
             <div className="col-md-12">
               <div className="row gx-4 mb-4">
                 {podcastDetailList &&
                   podcastDetailList.episodes &&
                   podcastDetailList.episodes.length > 0 &&
                   podcastDetailList.episodes.map((item) => (
                     <div className="col-md-6 mb-4">
                       {item.title != defaultAudio.title ? (
                         <div className="padcastcard">
                           <div className="p-3 row">
                             <div className="col-md-4 d-flex align-items-center justify-content-md-center podimage">
                               <a
                                 href="javascript:void(0)"
                                 className="podimage"
                                 onClick={(e) => handleChangeAudio(e, item)}
                               >
                                 <img
                                   src={item && item.thumbnail}
                                   className="img-fluid"
                                 />
                               </a>
                             </div>
                             <div className="col-md-8">
                               <a
                                 href="javascript:void(0)"
                                 onClick={(e) => handleChangeAudio(e, item)}
                               >
                                 <h3 className="bluecolor">
                                   {item.title ? item.title : ""}
                                 </h3>
                               </a>
                               <p className="my-3">
                                 {" "}
                                 {item.description ? item.description : ""}-
                                 <a href={item.url ? item.url : ""}>
                                   {item.url ? item.url : ""}
                                 </a>
                               </p>
                             </div>
                           </div>
                         </div>
                       ) : (
                         <div className="padcastcard podopacity">
                           <div className="row p-3">
                             <div className="col-md-4 d-flex align-items-center justify-content-md-center podimage">
                               <img
                                 src={item && item.thumbnail}
                                 className="img-fluid"
                               />
                             </div>
                             <div className="col-md-8">
                               <h3 className="bluecolor">
                                 {item.title ? item.title : ""}
                               </h3>

                               <p className="my-3">
                                 {" "}
                                 {item.description ? item.description : ""}-
                                 <a href={item.url ? item.url : ""}>
                                   {item.url ? item.url : ""}
                                 </a>
                               </p>
                             </div>
                           </div>
                         </div>
                       )}
                     </div>
                   ))}
               </div>
             </div>
           </div>
         </div>
       </div>
     </section>
   </div>
 );
};

const mapStateToProps = (state) => ({
 podcastDetailsList: state.LearnsCorners.cornerPodcastDetails,
 cornerOverviewList: state.LearnsCorners,
});

const mapDispatchToProps = (dispatch) => ({
 getCornerPodcastDetails: bindActionCreators(
   getCornerPodcastDetails,
   dispatch
 ),
 cornerSectionOverview: bindActionCreators(cornerSectionOverview, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PodcastDetail);